// extracted by mini-css-extract-plugin
export var label = "_qy-0";
export var link = "_qy-1";